import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import PageWrapper from '@/components/SupportSection/shared/PageWrapper';
import SupportBilling from '@components/SupportSection/SupportBilling';
import { WordPressAPI } from '@/config';

const BillingSupport = ({ data }) => (
  <PageWrapper data={data} breadcrumb={"Request Billing Support"}>
    <SupportBilling />
  </PageWrapper>
);

export const getStaticProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/20505`);

  return {
    props: {
      data: data.acf,
      pageTitle: 'Billing Support',
    },
    // revalidate: 1,
  };
};

BillingSupport.propTypes = {
  data: PropTypes.object,
  pageTitle: PropTypes.string,
};

export default BillingSupport;